module.exports = "https://web-assets.ifttt.com/packs/media/perks/location-5aafadb2.svg";